import React from 'react'

import { CardBulletPoint } from '@frame/ui-components/card-bullet-point'

import shield from '@frame/images/shield.svg'
import speedometer from '@frame/images/speedometer.svg'
import { DataAttribute } from '@frame/types'

export function ConsentCard() {
  return (
    <div
      data-cy={DataAttribute.CONSENT_CARD}
      className="flex flex-col space-y-5 rounded-md border-[2px] border-moss-200 p-5 pl-4"
    >
      <CardBulletPoint
        imgSrc={speedometer}
        title="Verify in seconds"
        subTitle="From employment or other sources"
        alignTop
      />
      <CardBulletPoint
        imgSrc={shield}
        title="Your data is shared securely"
        subTitle="Security is Truework's top priority"
        alignTop
      />
    </div>
  )
}
